import apiClient from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Dirary } from '../../../types/dirary';
import { userState } from '../../../states/userState';
import { formatDate } from '../../../utils/functions/formatting';
import { useCallback } from 'react';
import { WorkerWithDiary } from '../../../types';

const createAllDiaryList = (
  workers: WorkerWithDiary[],
  diaries: Dirary[]
): Dirary[] => {
  const allDiaryList: Dirary[] = [];

  workers.forEach((worker) => {
    diaries.forEach((diary) => {
      const newDiary = { ...diary }; // diaryをコピーして新しいオブジェクトを作成

      // workerListにある項目で上書き
      newDiary.workerId = worker.workerId;
      newDiary.workerName = worker.workerName;
      if (worker.departmentId !== null) {
        newDiary.departmentId = worker.departmentId;
      }
      if (worker.jobId !== null) {
        newDiary.jobId = worker.jobId;
      }
      newDiary.affiliationFactoryId = Number(worker.place);

      allDiaryList.push(newDiary);
    });
  });

  return allDiaryList;
};

export const useAddPosts = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const user = useRecoilValue(userState);
  const addPosts = useCallback(
    async (diaryList: Dirary[]) => {
      setLoadingAnimation(true);
      setLoadingText('登録中...');
      const createdAt = formatDate(new Date());
      const reqBody = {
        diaryList: diaryList,
      };
      try {
        const res = await apiClient.post(
          `/rocketForge/posts/addDiary/${
            user.mail ?? 'undefined@morimatsu.jp'
          }/${createdAt}`,
          reqBody
        );

        const data = res.data;
        return data;
        //   return 0;
      } catch (e) {
        window.alert('エラーが発生しました' + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText('');
      }
    },
    [loadingState, loadingText]
  );
  const addPostsAllWorkers = useCallback(
    async (diaryList: Dirary[], workerList: WorkerWithDiary[]) => {
      const allDiaryList = createAllDiaryList(workerList, diaryList);
      //成否判定のため addPosts の結果(成功=data / 失敗=null)をそのまま返す
      return await addPosts(allDiaryList);
    },
    [loadingState, loadingText]
  );
  return { addPosts, addPostsAllWorkers };
};
